import { WorkItemPool } from './workitem-pool';

// Enums
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';

// Models
import { WorkItemChatPinInvite } from './models/workitem-chat-pin-invite-model';
import { WorkItemComposeEmail } from './models/workitem-compose-email-model';
import { WorkItemLens } from './models/workitem-lens';
import { WorkItemEmail } from './models/work-item-email';
import { WorkItemChat } from './models/work-item-chat';
import { WorkItemSms } from './models/work-item-sms';
import { WorkItemFacebook } from './models/work-item-facebook';
import { WorkItem } from './interfaces/workitem-base.interface';
import { WorkItemAsyncMessage } from './models/work-item-async-message';
import { WorkItemDiscussion } from './models/work-item-discussion';
import { WorkItemHelper } from 'common/workitems/workitem-helper';

export class WorkItemFactory {
  static create(workItemType, workItem?) {
    const itemId = this._getWorkItemId(workItem);
    let wrappedElement = this._getWorkItemFromPoolById(itemId);
    if (wrappedElement) {
      Object.assign(wrappedElement, workItem); // Merge data into found element
      return wrappedElement;
    }

    wrappedElement = this._createNewWorkItemByTypeAndDescriptor(workItemType, workItem);

    return wrappedElement;
  }

  static wrap(workItem): WorkItem {
    const itemId = this._getWorkItemId(workItem);
    let wrappedElement = this._getWorkItemFromPoolById(itemId);
    if (wrappedElement) {
      return wrappedElement;
    }

    wrappedElement = this._createNewWorkItemByTypeAndDescriptor(workItem.type, workItem);

    return wrappedElement;
  }

  static _createNewWorkItemByTypeAndDescriptor(type, descriptor): WorkItem {
    let workItemType = type;
    if (!workItemType && descriptor) {
      workItemType = this._extractTypeFromDescriptor(descriptor);
    }

    switch (workItemType) {
      case WorkItemTypes.COMPOSE_EMAIL:
        return new WorkItemComposeEmail(descriptor);
      case WorkItemTypes.CHAT_PIN_INVITE:
        if (descriptor.pinvitationId) {
          descriptor.ItemID = descriptor.pinvitationId;
        }
        return new WorkItemChatPinInvite(descriptor);
      case WorkItemTypes.CHAT:
        return new WorkItemChat(descriptor);
      case WorkItemTypes.EMAIL:
        return new WorkItemEmail(descriptor);
      case WorkItemTypes.SMS:
        return new WorkItemSms(descriptor);
      case WorkItemTypes.FACEBOOK:
        return new WorkItemFacebook(descriptor);
      case WorkItemTypes.ASYNC_MESSAGE:
        return new WorkItemAsyncMessage(descriptor);
      case WorkItemTypes.LENS:
        return new WorkItemLens(descriptor);
      case WorkItemTypes.DISCUSSION:
        return new WorkItemDiscussion(descriptor);
      default:
        throw new Error(`Unhandled workItem type in WorkItemFactory (${workItemType})`);
    }
  }

  static _extractTypeFromDescriptor(descriptor) {
    if (descriptor.ItemType) {
      return WorkItemHelper.convertDbEnumToItemType(descriptor.ItemType);
    } else if (typeof descriptor.type !== 'undefined') {
      return descriptor.type;
    } else {
      throw new Error(`Missing workItem type [Descriptor: ${JSON.stringify(descriptor)}]`);
    }
  }

  static _getWorkItemId(workItem) {
    return workItem ? workItem._id || workItem.ItemID : null;
  }

  static _getWorkItemFromPoolById(itemId) {
    return WorkItemPool.getInstance().getWorkItemById(itemId);
  }
}
